/* DZYN Mandir finder + matched products (think27, 25-Sep-2026) - sections/think27-pk-match.liquid.
   Questions -> best mandir type (family scoring from the city-page design) + the collection's products
   filtered on the SAME fields the storefront filters use, never more than cfg.max (12).
   The product list is fetched once (sections/think27-match-data) when the finder comes into view. */
(function () {
  'use strict';
  var FIELD = { type: 'mt', height: 'hb', doors: 'dt', storage: 'st', style: 'sy', finish: 'fi' };
  var SND = { type: 'filter.p.m.dzyn.mandir_type', height: 'filter.p.m.dzyn.height_band', doors: 'filter.p.m.dzyn.door_type', storage: 'filter.p.m.dzyn.storage', style: 'filter.p.m.dzyn.style', finish: 'filter.p.m.dzyn.finish' };
  var TYPE_L = { 'wall mounted': 'Wall mount', 'floor rested': 'Floor rested', 'pooja mandap': 'Pooja mandap', 'cabinet mandir': 'Cabinet mandir' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function enc(s) { return encodeURIComponent(s); }
  function lc(s) { return String(s || '').toLowerCase().trim(); }

  /* "type=Wall Mounted,Floor Rested; price=0-10000" -> [{f:'type', v:['wall mounted','floor rested']}, ...] */
  function parseFilter(str) {
    var out = [];
    String(str || '').split(';').forEach(function (cl) {
      var i = cl.indexOf('=');
      if (i < 1) return;
      var f = lc(cl.slice(0, i)), vals = cl.slice(i + 1).split(',').map(lc).filter(Boolean);
      if (vals.length) out.push({ f: f, v: vals });
    });
    return out;
  }
  function parseMatch(str) {
    var m = {};
    parseFilter(str).forEach(function (c) { m[c.f] = c.v; });
    return m;
  }
  function range(v) { var p = String(v).split('-'); return [p[0] === '' ? 0 : +p[0], p[1] === undefined || p[1] === '' ? Infinity : +p[1]]; }
  function clauseOk(p, c) {
    if (FIELD[c.f]) {
      var pv = p[FIELD[c.f]];
      if (Array.isArray(pv)) return pv.some(function (x) { return c.v.indexOf(lc(x)) > -1; });
      return c.v.indexOf(lc(pv)) > -1;
    }
    if (c.f === 'tag') { var tg = (p.tg || '').split('|'); return c.v.some(function (v) { return tg.indexOf(v) > -1; }); }
    if (c.f === 'price' || c.f === 'width' || c.f === 'tall') {
      var n = c.f === 'price' ? p.p / 100 : c.f === 'width' ? p.wi : p.hi;
      if (!n) return false;
      return c.v.some(function (v) { var r = range(v); return n >= r[0] && n <= r[1]; });
    }
    if (c.f === 'ship') return c.v.some(function (v) { return v === 'express' ? p.x === 'x' : p.x !== 'm'; });
    return true;
  }

  function init(root) {
    var cfgEl = root.parentNode.querySelector('script[data-t27m-cfg]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var T = cfg.t, Q = cfg.q || [], F = cfg.f || [], N = Q.length;
    Q.forEach(function (q) { q.o = (q.o || []).map(function (o) { return { v: o[0], l: o[1], s: o[2], f: parseFilter(o[3]) }; }); });
    F.forEach(function (f) { f.mm = parseMatch(f.m); f.xx = parseMatch(f.x); });

    var $ = function (sel) { return root.querySelector(sel); };
    var st = { a: {}, i: 0, sort: 'match' };
    var data = null, loading = null;

    /* ---------- product list: fetched once, all pages in parallel ---------- */
    function load() {
      if (data) return Promise.resolve(data);
      if (loading) return loading;
      if (!cfg.coll) return Promise.resolve([]);
      var key = 't27m:' + cfg.coll;
      try { var c = sessionStorage.getItem(key); if (c) { data = JSON.parse(c); return Promise.resolve(data); } } catch (e) {}
      var get = function (pg) {
        return fetch(cfg.coll + (cfg.coll.indexOf('?') > -1 ? '&' : '?') + 'section_id=think27-match-data&page=' + pg, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var d = document.createElement('div'); d.innerHTML = html;
            var s = d.querySelector('script[data-t27m-data]');
            if (!s) return { rows: [], pages: 1 };
            return { rows: JSON.parse(s.textContent || '[]'), pages: +s.getAttribute('data-pages') || 1 };
          }).catch(function () { return { rows: [], pages: 1 }; });
      };
      loading = get(1).then(function (first) {
        var more = [];
        for (var p = 2; p <= Math.min(first.pages, 6); p++) more.push(get(p));
        return Promise.all(more).then(function (rest) {
          var all = first.rows;
          rest.forEach(function (r) { all = all.concat(r.rows); });
          all.forEach(function (p, i) { p.o = i; });
          data = all.filter(function (p) { return p.av; });
          try { sessionStorage.setItem(key, JSON.stringify(data)); } catch (e) {}
          return data;
        });
      });
      return loading;
    }

    function answered() { return Q.filter(function (q) { return st.a[q.id] && st.a[q.id] !== 'x'; }); }
    function opt(q) { var v = st.a[q.id]; for (var i = 0; i < q.o.length; i++) if (q.o[i].v === v) return q.o[i]; return null; }
    function lbl(id) { for (var i = 0; i < Q.length; i++) if (Q[i].id === id) { var o = opt(Q[i]); return o ? o.l : ''; } return ''; }
    function has(id) { return st.a[id] && st.a[id] !== 'x'; }

    /* ---------- families (design scoring) ---------- */
    function rankFamilies() {
      var any = answered().length > 0;
      if (!any) {
        var d = (cfg.def || []).map(function (k) { return F.filter(function (f) { return f.id === k; })[0]; }).filter(Boolean);
        F.forEach(function (f) { if (d.indexOf(f) < 0) d.push(f); });
        return d.slice(0, 3).map(function (f) { return { f: f, pct: 0 }; });
      }
      var r = F.map(function (f, idx) {
        var sc = 0, mx = 0;
        Q.forEach(function (q) {
          if (!has(q.id)) return;
          var w = +q.w || 0; mx += w;
          if (f.custom) sc += w * 0.55;
          else if (f.mm[q.id] && f.mm[q.id].indexOf(lc(st.a[q.id])) > -1) sc += w;
          if (f.xx[q.id] && f.xx[q.id].indexOf(lc(st.a[q.id])) > -1) sc -= 2;
        });
        return { f: f, idx: idx, pct: mx ? Math.max(40, Math.round(55 + 44 * (sc / mx))) : 0 };
      }).sort(function (a, b) { return b.pct - a.pct || a.idx - b.idx; }).slice(0, 3);
      if (r[1] && r[1].pct >= r[0].pct) r[1].pct = Math.max(40, r[0].pct - 2);
      if (r[2] && r[1] && r[2].pct >= r[1].pct) r[2].pct = Math.max(40, r[1].pct - 2);
      return r;
    }
    function links(f, extra) {
      var h = '';
      f.l.forEach(function (l) { if (l[0] && l[1]) h += '<a class="pk-link" href="' + esc(l[1]) + '">' + esc(l[0]) + ' <span class="pk-arrow" aria-hidden="true">&rarr;</span></a>'; });
      return h + (extra || '');
    }
    function renderFamilies() {
      var r = rankFamilies(), any = answered().length > 0;
      if (!r.length) return;
      var top = r[0], f = top.f;
      var img = root.querySelector('[data-t27m-bimg]');
      if (img && f.img) { img.removeAttribute('srcset'); img.src = f.img; img.alt = f.name; }
      else if (!img && f.img) { var bim = $('.t27m-bim'); if (bim) bim.insertAdjacentHTML('afterbegin', '<img class="t27m-bimg" data-t27m-bimg src="' + esc(f.img) + '" alt="' + esc(f.name) + '" loading="lazy">'); }
      $('[data-t27m-btag]').textContent = any ? T.best.replace('[p]', top.pct) : T.start;
      $('[data-t27m-bname]').textContent = f.name;
      $('[data-t27m-bwhy]').textContent = f.why;
      var sd = T.specDef, idols = lbl('idols');
      var vals = [
        has('ht') ? lbl('ht') : f.ht,
        has('wd') ? lbl('wd') : sd.width,
        idols && has('idols') ? sd.idolsFit.replace('[a]', idols) : sd.idols,
        has('doors') ? lbl('doors') : f.doors,
        has('fin') ? lbl('fin') : sd.finish,
        f.price,
        st.a.when === 'soon' ? sd.fast : sd.mto,
        sd.wood
      ];
      $('[data-t27m-spec]').innerHTML = T.spec.map(function (k, i) { return '<div><dt>' + esc(k) + '</dt><dd>' + esc(vals[i]) + '</dd></div>'; }).join('');
      $('[data-t27m-blinks]').innerHTML = links(f);
      var send = $('[data-t27m-send]');
      if (send && cfg.wa) {
        var sum = Q.filter(function (q) { return st.a[q.id]; }).map(function (q) { return q.k + ': ' + (st.a[q.id] === 'x' ? T.notSure : lbl(q.id)); }).join('; ');
        send.href = cfg.wa + enc(T.waFinder.replace('[answers]', sum ? sum + '.' : '').replace('[match]', any ? ' Best match: ' + f.name + '.' : '').replace(/\s+/g, ' '));
      }
      $('[data-t27m-alts]').innerHTML = r.slice(1).map(function (x) {
        var wa = cfg.wa ? '<a class="pk-link" href="' + esc(cfg.wa + enc(T.waAlt.replace('[type]', x.f.name.toLowerCase()))) + '" target="_blank" rel="noopener">' + esc(T.waAltLabel) + ' <span class="pk-arrow" aria-hidden="true">&rarr;</span></a>' : '';
        return '<div class="t27m-alt"><div class="t27m-aim">' + (x.f.imgS ? '<img src="' + esc(x.f.imgS) + '" alt="' + esc(x.f.name) + '" loading="lazy">' : '') +
          '<span class="t27m-tag t27m-tag--s">' + esc(any ? T.pct.replace('[p]', x.pct) : T.popular) + '</span></div><div class="t27m-abd"><h4 class="t27m-aname">' + esc(x.f.name) +
          '</h4><p class="t27m-awhy">' + esc(x.f.why) + '</p><p class="t27m-links">' + links(x.f, any ? wa : '') + '</p></div></div>';
      }).join('');
    }

    /* ---------- products ---------- */
    function meta(p) {
      var parts = [TYPE_L[lc(p.mt)] || p.mt, String(p.hb || '').replace(' Feet', ' ft'), p.fi, p.dt && lc(p.dt) !== 'without doors' ? 'Doors' : ''];
      return parts.filter(Boolean).join(' · ');
    }
    function card(p, badge, isMatch, why) {
      var save = p.c > p.p ? Math.floor((p.c - p.p) * 100 / p.c) : 0;
      var line = why || [p.w, p['in']].filter(Boolean).join(' · ');
      var img = p.i ? '<img class="t27m-img" src="' + esc(p.i) + '" srcset="' + esc(p.i) + ' 400w, ' + esc(p.j) + ' 700w" sizes="(min-width: 1100px) 22vw, (min-width: 701px) 30vw, 46vw" alt="' + esc(p.a || p.t) + '" loading="lazy" width="400" height="500">' : '';
      return '<article class="t27m-card" data-h="' + esc(p.h) + '"><div class="t27m-im">' + img + (badge ? '<span class="t27m-badge' + (isMatch ? ' is-match' : '') + '">' + esc(badge) + '</span>' : '') +
        '</div><div class="t27m-bd"><h3 class="t27m-name"><a class="t27m-lk" href="' + esc(p.u) + '">' + esc(p.t) + '</a></h3>' +
        (meta(p) ? '<p class="t27m-meta">' + esc(meta(p)) + '</p>' : '') +
        '<p class="t27m-price"><b>' + esc(p.pf) + '</b>' + (save > 0 ? ' <s>' + esc(p.cf) + '</s> <span class="t27m-save">Save ' + save + '%</span>' : '') + '</p>' +
        (line ? '<p class="t27m-why">' + esc(line) + '</p>' : '') +
        (cfg.wa ? '<a class="t27m-wa" href="' + esc(cfg.wa + enc(T.waProduct.replace('[product]', p.t))) + '" target="_blank" rel="noopener">' + esc(T.waLabel) + ' <span aria-hidden="true">&rarr;</span></a>' : '') +
        '</div>' + (p.sh ? '<p class="t27m-ship">' + esc(p.sh) + '</p>' : '') + '</article>';
    }
    function renderProducts() {
      var box = $('[data-t27m-cards]'), ans = answered();
      var fq = ans.map(function (q) { return { q: q, o: opt(q) }; }).filter(function (x) { return x.o && x.o.f.length; });
      if (!data) return;
      var totalW = fq.reduce(function (s, x) { return s + (+x.q.w || 1); }, 0);
      var rows = data.map(function (p) {
        var sc = 0, hit = 0, why = [];
        fq.forEach(function (x) {
          var ok = x.o.f.every(function (c) { return clauseOk(p, c); });
          if (ok) { sc += (+x.q.w || 1); hit++; why.push(x.o.l); }
        });
        return { p: p, sc: sc, hit: hit, full: hit === fq.length, why: why };
      });
      var ship = { x: 0, '7': 1, m: 2 };
      var bySort = function (a, b) {
        if (st.sort === 'low') return a.p.p - b.p.p;
        if (st.sort === 'high') return b.p.p - a.p.p;
        if (st.sort === 'fast') return ship[a.p.x] - ship[b.p.x] || b.p.s - a.p.s;
        return fq.length ? (b.p.s - a.p.s) : (a.p.o - b.p.o);
      };
      var full = rows.filter(function (r) { return r.full; });
      var list;
      if (!fq.length) list = rows.slice().sort(bySort).slice(0, cfg.max);
      else if (full.length >= cfg.max) list = full.sort(bySort).slice(0, cfg.max);
      else {
        /* every full match, then the closest (most answers met, best sellers first); a chosen sort
           then orders the shown cards, full matches still first */
        var rest = rows.filter(function (r) { return !r.full; }).sort(function (a, b) { return b.sc - a.sc || b.p.s - a.p.s; });
        list = full.sort(bySort).concat(rest.slice(0, cfg.max - full.length));
        if (st.sort !== 'match') list.sort(function (a, b) { return (b.full - a.full) || bySort(a, b); });
      }
      var nFull = fq.length ? full.length : 0;
      box.innerHTML = list.map(function (r) {
        if (!fq.length) return card(r.p, r.p.s > 0 && T.sold ? T.sold.replace('[n]', r.p.s) : '', false, '');
        var pct = totalW ? Math.round(100 * r.sc / totalW) : 100;
        var badge = r.full ? T.match.replace('[p]', 100) : (T.closeBadge ? T.closeBadge.replace('[p]', pct) : T.match.replace('[p]', pct));
        return card(r.p, badge, r.full, r.why.length ? T.why + r.why.slice(0, 3).join(' · ') : '');
      }).join('');
      box.classList.remove('is-busy');
      var nAns = Q.filter(function (q) { return st.a[q.id]; }).length;
      $('[data-t27m-peye]').textContent = ans.length ? T.eye1.replace('[a]', ans.length) : T.eye0;
      $('[data-t27m-ptitle]').textContent = !fq.length ? T.title0 : nFull ? T.title1.replace('[n]', nFull) : T.title2;
      var note = $('[data-t27m-note]');
      if (fq.length && nFull < list.length) { note.textContent = nFull ? T.close.replace('[n]', nFull) : T.none; note.hidden = false; } else note.hidden = true;
      var first = root.querySelector('[data-sort="match"]');
      if (first) first.textContent = ans.length ? T.sortMatch : T.sortPopular;
      /* "See all" -> the collection with the storefront filters (Search & Discovery) for these answers */
      var all = $('[data-t27m-all]');
      if (all && cfg.coll) {
        var qs = [];
        fq.forEach(function (x) { x.o.f.forEach(function (c) {
          if (SND[c.f]) c.v.forEach(function (v) { qs.push(SND[c.f] + '=' + enc(capital(v, x.o.f, c.f))); });
          else if (c.f === 'price') { var r = range(c.v[0]); if (r[0]) qs.push('filter.v.price.gte=' + r[0]); if (r[1] !== Infinity) qs.push('filter.v.price.lte=' + r[1]); }
        }); });
        all.href = cfg.coll + (qs.length ? '?' + qs.join('&') : '');
        all.textContent = (fq.length && nFull ? T.allMatch.replace('[n]', nFull) : T.all.replace('[n]', data.length));
      }
      var sh = $('[data-t27m-short]');
      if (sh && cfg.wa) sh.href = cfg.wa + enc(T.waShort.replace('[list]', list.slice(0, 6).map(function (r) { return r.p.t; }).join(', ')));
    }
    /* filter values are matched lower-case; the storefront filter wants the stored value's case */
    function capital(v, clauses, f) {
      if (!data) return v;
      var k = FIELD[f];
      for (var i = 0; i < data.length; i++) {
        var pv = data[i][k];
        var arr = Array.isArray(pv) ? pv : [pv];
        for (var j = 0; j < arr.length; j++) if (lc(arr[j]) === v) return arr[j];
      }
      return v;
    }

    /* ---------- question panel ---------- */
    function renderPanel() {
      var done = st.i >= N, q = Q[Math.min(st.i, N - 1)];
      $('[data-t27m-step]').textContent = done ? T.done.replace('[n]', N) : T.step.replace('[i]', st.i + 1).replace('[n]', N);
      $('[data-t27m-bar]').style.width = (Math.min(st.i, N) / N * 100) + '%';
      $('[data-t27m-q]').textContent = done ? T.doneQ : q.t;
      $('[data-t27m-hint]').textContent = done ? T.doneH : q.h;
      var opts = $('[data-t27m-opts]');
      opts.hidden = done;
      if (!done) {
        opts.setAttribute('aria-label', q.t);
        opts.innerHTML = q.o.map(function (o) {
          return '<button type="button" class="t27m-opt" data-v="' + esc(o.v) + '" aria-pressed="' + (st.a[q.id] === o.v) + '"><b>' + esc(o.l) + '</b>' + (o.s ? '<span>' + esc(o.s) + '</span>' : '') + '</button>';
        }).join('');
      }
      var ans = $('[data-t27m-ans]');
      var list = Q.map(function (qq, i) { return { qq: qq, i: i }; }).filter(function (x) { return st.a[x.qq.id]; });
      ans.hidden = !(done && list.length);
      ans.innerHTML = list.map(function (x) { return '<button type="button" data-go="' + x.i + '"><b>' + esc(x.qq.k) + ':</b> ' + esc(st.a[x.qq.id] === 'x' ? T.notSure : lbl(x.qq.id)) + '</button>'; }).join('');
      $('[data-t27m-back]').disabled = st.i === 0;
      $('[data-t27m-skip]').hidden = done;
      $('[data-t27m-reset]').hidden = !Object.keys(st.a).length;
    }
    function update() {
      renderPanel();
      renderFamilies();
      if (data) renderProducts();
      else if (answered().length || st.sort !== 'match') {
        $('[data-t27m-cards]').classList.add('is-busy');
        load().then(renderProducts);
      }
    }
    function next() {
      st.i = Math.min(N, st.i + 1);
      update();
      if (st.i >= N) { var top = root.getBoundingClientRect().top + window.scrollY - 150; window.scrollTo({ top: top, behavior: 'smooth' }); }
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !root.contains(b)) return;
      if (b.classList.contains('t27m-opt')) { var q = Q[Math.min(st.i, N - 1)]; st.a[q.id] = b.getAttribute('data-v'); next(); }
      else if (b.hasAttribute('data-t27m-back')) { st.i = Math.max(0, st.i - 1); update(); }
      else if (b.hasAttribute('data-t27m-skip')) next();
      else if (b.hasAttribute('data-t27m-reset')) { st.a = {}; st.i = 0; update(); }
      else if (b.hasAttribute('data-go')) { st.i = +b.getAttribute('data-go'); update(); }
      else if (b.hasAttribute('data-sort')) {
        st.sort = b.getAttribute('data-sort');
        root.querySelectorAll('[data-sort]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        update();
      }
    });

    /* fetch the product list while the visitor reads the first question */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); (window.requestIdleCallback || setTimeout)(function () { load(); }); }
      }, { rootMargin: '400px' });
      io.observe(root);
    }
  }

  function boot() { document.querySelectorAll('[data-t27m]').forEach(function (r) { if (!r.__t27m) { r.__t27m = 1; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
